import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaLongArrowAltRight } from "react-icons/fa";

const BackDatedReport = () => {
  const [TrOutletId, setOutlet] = useState(null);
  const [saleSummarydata, setsaleSummarydata] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);

  const openingCash = parseFloat(localStorage.getItem("OpeningCash") || 0);
  const openingOfficeCash = parseFloat(localStorage.getItem("OpeningOfficeCash") || 0);

  const apiUrl = process.env.REACT_APP_SERVER_API;

  useEffect(() => {
    const selectedOutlet = JSON.parse(localStorage.getItem("SelectedOutlet"));
    if (selectedOutlet) {
      setOutlet(selectedOutlet);
    }
  }, []);

  const fetchSaleSummary = async (outletId, date) => {
    try {
      const formattedDate = new Date(date).toISOString().split("T")[0];
      const response = await axios.get(`${apiUrl}accounts-history`, {
        params: {
          Outlet_Id: outletId,
          Tr_date: formattedDate,
        },
      });
      setsaleSummarydata(response.data);
    } catch (error) {
      console.error("Error fetching sale summary:", error);
    }
  };

  

  const fetchCashBalances = async (outletId , selectedDate) => {
    try {
      const resp = await axios.get(`${apiUrl}cash-SummaryByOutletAndDate`, {
        params: { outletId, summaryDate: selectedDate },
      });
      const { OpeningCash, OfficeOpeningCash, SummaryDate , GST , VAT } = resp.data.data;
      localStorage.setItem("OpeningCash", OpeningCash);
      localStorage.setItem("OpeningOfficeCash", OfficeOpeningCash);
      localStorage.setItem("GSTAmount", GST);
      localStorage.setItem("VATAmount", VAT);

      const dateObj = new Date(SummaryDate);
      const formattedDate = `${String(dateObj.getDate()).padStart(2, "0")}/${String(dateObj.getMonth() + 1).padStart(2, "0")}/${dateObj.getFullYear()}`;
      localStorage.setItem("SummaryDate", formattedDate);
    } catch (error) {
      console.error("Error fetching cash balances:", error);
    }
  };

  const handleShowBackDate = () => {
    if (TrOutletId?.outlate_id && selectedDate) {
      fetchSaleSummary(TrOutletId.outlate_id, selectedDate);
      fetchCashBalances(TrOutletId.outlate_id , selectedDate);
    }
  };

  const changeDate = (direction) => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + direction);
    setSelectedDate(newDate.toISOString().split("T")[0]);
  };

  // Total Sale Amount
  const TotalSaleItem = saleSummarydata.find(
    (item) =>
      item.MainAc_id === 3 && item.SubAc_id === 1 && item.SubsubAc_id === 1
  );

  const TotalSaleAmount = TotalSaleItem ? parseFloat(TotalSaleItem.AmtCash) : 0;
  // External Sale Amount
  const ExternalSaleItem = saleSummarydata.find(
    (item) =>
      item.SubAc_id === 1 && item.MainAc_id === 3 && item.SubsubAc_id === 2
  );

  const ExternalSaleAmount = ExternalSaleItem
    ? parseFloat(ExternalSaleItem.AmtCash)
    : 0;

  //  Total Sale By Credit
  const TotCrSaleItems = saleSummarydata.filter(
    (item) => item.MainAc_id === 2 && item.SubAc_id >= 2 && item.SubAc_id < 50
  );

  const TotalSaleCrAmount = TotCrSaleItems.reduce((total, item) => {
    return total + Number(item.AmtBank || 0);
  }, 0);

  // Cash Sale Amount
  const cashSales = saleSummarydata
    .filter(
      (item) =>
        item.MainAc_id === 3 &&
        item.SubAc_id === 1 &&
        (item.SubsubAc_id === 1 || item.SubsubAc_id === 2)
    )
    .reduce((sum, item) => sum + parseFloat(item.AmtCash || 0), 0);

  const bankPurchases = saleSummarydata
    .filter((item) => item.MainAc_id === 2 && item.SubAc_id === 2)
    .reduce((sum, item) => sum + parseFloat(item.AmtBank || 0), 0);

  const CashSaleAmount = (cashSales - bankPurchases).toFixed(2);

  // Add Office Cash

  const AddOfficeCash = saleSummarydata.find(
    (item) =>
      item.MainAc_id === 2 &&
      item.SubAc_id === 99 &&
      item.SubsubAc_id === 2 &&
      item.CrDr === "DR"
  );

  const AddOfficeCashAmount = parseFloat(AddOfficeCash?.AmtCash || 0);

  const todaysTotalCash = (
    parseFloat(openingCash || 0) +
    saleSummarydata
      .filter(
        (item) =>
          item.MainAc_id === 2 &&
          item.SubAc_id === 99 &&
          item.SubsubAc_id === 2 &&
          item.CrDr === "DR"
      )
      .reduce((sum, item) => sum + parseFloat(item.AmtCash || 0), 0) +
    saleSummarydata
      .filter(
        (item) =>
          item.MainAc_id === 3 &&
          item.SubAc_id === 1 &&
          (item.SubsubAc_id === 1 || item.SubsubAc_id === 2)
      )
      .reduce((sum, item) => sum + parseFloat(item.AmtCash || 0), 0) -
    saleSummarydata
      .filter((item) => item.MainAc_id === 2 && item.SubAc_id === 2)
      .reduce((sum, item) => sum + parseFloat(item.AmtBank || 0), 0)
  ).toFixed(2);

  // Extract sale data
  const findItem = (condition) => saleSummarydata.find(condition);

  const LessOfficeCash = findItem(
    (item) =>
      item.MainAc_id == 2 &&
      item.SubAc_id == 99 &&
      item.SubsubAc_id == 2 &&
      item.CrDr == "CR"
  );
  const LessGstAndVat = findItem(
    (item) =>
      item.MainAc_id === 2 && item.SubAc_id === 99 && item.SubsubAc_id === 3
  );
  const PendingBill = findItem(
    (item) =>
      item.MainAc_id === 4 && item.SubAc_id === 99 && item.SubsubAc_id === 1
  );

  // Convert to numbers safely
  const num = (value) => Number(value || 0);

  // Then calculate the total sale amoun
  const lessOfficeCashAmount = num(LessOfficeCash?.AmtCash);
  const lessGSTAndVatAmount = num(LessGstAndVat?.AmtCash);
  const PendingBillAmount = num(PendingBill?.AmtCash);

  // Expenses summary
  const expenses = saleSummarydata.filter(
    (item) => item.MainAc_id === 4 && item.SubAc_id >= 1 && item.SubAc_id < 99
  );

  const totalAmtCash = expenses.reduce(
    (sum, item) => sum + num(item.AmtCash),
    0
  );
  const totalAmtBank = expenses.reduce(
    (sum, item) => sum + num(item.AmtBank),
    0
  );
  const LessCashBankExpe = totalAmtCash + totalAmtBank;

  const BalanceCashtotal =
    todaysTotalCash -
    LessCashBankExpe -
    lessOfficeCashAmount -
    lessGSTAndVatAmount;

  return (
    <div className="container-fluid p-0">
      <div className="row">
        <div className="col-md-12">
          <div className="d-flex justify-content-between">
            <div className="form-check">
              <input className="form-check-input" type="radio" name="dateOption" checked readOnly />
              <label className="form-check-label">Back Date</label>
              <div className="d-flex align-items-center mt-2">
                <input
                  type="date"
                  className="form-control me-2 p-0"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                />
                <button className="btn btn-success me-2 p-1" style={{ width: "55px" }} onClick={() => changeDate(-1)}>Prev</button>
                <button className="btn btn-success p-1 me-2" style={{ width: "55px" }} onClick={() => changeDate(1)}>Next</button>
                <button className="btn btn-primary me-2 p-1" onClick={handleShowBackDate}>Show</button>
              </div>
            </div>
          </div>

          {/* Report Display */}
          <div className="border mt-2 p-3">
            <h6>Reports</h6>
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Sale Summary
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <div className="d-flex justify-content-end mb-2">
                      <label className="me-4 mt-1">
                        Total Sale <FaLongArrowAltRight />
                      </label>
                      <input
                        readOnly
                        type="text"
                        className="form-control text-end"
                        style={{ width: "100px" }}
                        value={TotalSaleAmount}
                      />
                    </div>
                    <div className="d-flex justify-content-end mb-2">
                      <label className="me-4 mt-1">
                        External Sale <FaLongArrowAltRight />
                      </label>
                      <input
                        readOnly
                        type="text"
                        className="form-control text-end"
                        style={{ width: "100px" }}
                        value={ExternalSaleAmount}
                      />
                    </div>
                    {/* Sale Summary Table */}
                    <table className="table border">
                      <thead>
                        <tr>
                          <th>Accounts</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {saleSummarydata.length > 0 ? (
                          saleSummarydata
                            .filter(
                              (item) =>
                                item.MainAc_id === 2 && item.SubAc_id === 2
                            )
                            .map((item) => (
                              <tr key={item.Tr_Id}>
                                <td className="border">{item.Narration}</td>
                                <td className="border text-end">
                                  {Number(item.AmtBank).toFixed(2)}
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center text-muted">
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* Sale Summaries */}
                    <div className="d-flex justify-content-end">
                      <label className="me-1 mt-1">
                        Total Sale By Credit <FaLongArrowAltRight />
                      </label>
                      <input
                        readOnly
                        type="text"
                        className="form-control text-end"
                        style={{ width: "100px" }}
                        value={TotalSaleCrAmount.toFixed(2)}
                      />
                    </div>
                    <div className="d-flex justify-content-end">
                      <label className="me-4 mt-1">
                        Cash Sale <FaLongArrowAltRight />
                      </label>
                      <input
                        readOnly
                        type="text"
                        className="form-control text-end"
                        style={{ width: "100px" }}
                        value={CashSaleAmount}
                      />
                    </div>

                    {/* Cash Calculation */}
                    <h5 className="text-center mt-3">Cash Calculation</h5>
                    {[
                      ["Cash Sale", CashSaleAmount],
                      ["Opening Cash", openingCash],
                      ["Add Office Cash", AddOfficeCashAmount],
                      ["Today's Total Cash", todaysTotalCash],
                      ["Less Cash Expenses", LessCashBankExpe],
                      ["Less Office Cash", lessOfficeCashAmount],
                      ["Less Cash To HO", lessGSTAndVatAmount],
                      ["Balance Cash", BalanceCashtotal],
                    ].map(([label, value], index) => (
                      <div
                        className="d-flex justify-content-end mt-1"
                        key={index}
                      >
                        <label className="text-start me-1 mt-1">
                          {label} <FaLongArrowAltRight />
                        </label>
                        <input
                          readOnly
                          type="text"
                          className="form-control text-end"
                          style={{ width: "120px" }}
                          value={value}
                        />
                      </div>
                    ))}

                    {/* Pending Bills */}
                    <div className="d-flex justify-content-end mt-4 border p-1">
                      <label className="me-4 mt-1">
                        Pending Bills Total <FaLongArrowAltRight />
                      </label>
                      <input
                        readOnly
                        type="text"
                        className="form-control text-end"
                        style={{ width: "100px" }}
                        value={PendingBillAmount.toFixed(2)}
                      />
                    </div>


                    <div className="d-flex justify-content-end mt-1 p-1">
                      <label className="me-4 mt-1">
                        GST Amount <FaLongArrowAltRight />
                      </label>
                      <input
                        readOnly
                        type="text"
                        className="form-control text-end"
                        style={{ width: "100px" }}

                        value={Number(localStorage.getItem("GSTAmount")) || 0}

                      />
                    </div>

                    <div className="d-flex justify-content-end  p-1">
                      <label className="me-4 mt-1">
                        VAT Amount <FaLongArrowAltRight />
                      </label>
                      <input
                        readOnly
                        type="text"
                        className="form-control text-end"
                        style={{ width: "100px" }}

                        value={Number(localStorage.getItem("VATAmount")) || 0}

                      />
                    </div>

                    {/* Expenses Table */}
                    <div className="col-md-5 text-center">
                      <h5>Expenses</h5>
                      <div>
                        <table className="table tblcss">
                          <thead className="align-middle text-center">
                            <tr>
                              <th className="tdcss" style={{ width: "300px" }}>
                                Particulars
                              </th>
                              <th className="tdcss">Cash Rs.</th>
                              <th className="tdcss">Bank Rs.</th>
                            </tr>
                          </thead>
                          <tbody>
                            {expenses.map((item) => (
                              <tr key={item.Tr_Id}>
                                <td className="tdcss text-start">
                                  {item.Narration}
                                </td>
                                <td className="tdcss text-end">
                                  {num(item.AmtCash).toFixed(2)}
                                </td>
                                <td className="tdcss text-end">
                                  {num(item.AmtBank).toFixed(2)}
                                </td>
                              </tr>
                            ))}
                            <tr className="fw-bold">
                              <td className="tdcss">Total</td>
                              <td className="tdcss text-end">
                                {totalAmtCash.toFixed(2)}
                              </td>
                              <td className="tdcss text-end">
                                {totalAmtBank.toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* End Expenses */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackDatedReport;
